import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  VStack,
  Box,
  HStack,
  Input,
  Checkbox,
} from "@chakra-ui/react";
import { AddLotteryModalProps, LotteryDto } from "../api/Dtos";
//import { OfiDateTimeRangePicker } from "../HelperComponents/DateTimePickers";
import { useGlobalContext } from "../Layout/GlobalState";

const AddLotteryModal: React.FC<AddLotteryModalProps> = ({
  isOpen,
  onClose,
  onAddRow,
}) => {
  const globalContext = useGlobalContext();
  const competitionId = globalContext.competition?.id || null;
  const [name, setName] = useState<string>("");
  const [disciplinesCond, setDisciplinesCond] = useState<string>("");
  const [startnumberSequencesCond, setStartnumberSequencesCond] = useState<string>("");
  const [teamNameCond, setTeamNameCond] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [nrOfWinners, setNrOfWinners] = useState<number>(5);
  const [completedCond, setCompletedCond] = useState<boolean>(false);

  const handleSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    //console.info('id: ' + id + ', starttime_planned: ' + starttime_planned );
    if (competitionId && name) {
      onAddRow({
        id: 0,
        competitionId: competitionId,
        name: name,
        disciplinesCond: disciplinesCond,
        startnumberSequencesCond: startnumberSequencesCond,
        teamNameCond: teamNameCond,
        description: description,
        nrOfWinners: nrOfWinners,
        completedCond: completedCond,
      });
    }
    // setStartTimePlannedInMs(null);
    // setEndTimePlannedInMs(null);
    // setStartTimeActualInMs(null);
    // setEndTimeActualInMs(null);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={"full"}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Lägg till ett pris att lotta ut</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={10}>
            <Box
              borderRadius={"10px"}
              background={"blue.200"}
              padding={"40px"}
              shadow={"2xl"}
            >
              <Text fontSize={"24px"}>Specificera priset</Text>
              <HStack spacing={10}>
                <VStack align="left">
                <Text fontSize={"18px"}>Prisets namn</Text>
                <Input
                    minW={100}
                    placeholder="Ange namn på priset"
                    onChange={(event) => {
                    setName(event.currentTarget.value);
                    }}
                />
                </VStack>
                <VStack align="left">
                <Text fontSize={"18px"}>Antal vinnare</Text>
                <Input
                    minW={100} 
                    placeholder="Ange antal vinnare"
                    onChange={(event) => {
                    if (nrOfWinners === parseInt(event.currentTarget.value)) {
                        setNrOfWinners(5);
                    } else {
                        setNrOfWinners(parseInt(event.currentTarget.value));
                    }
                    }}
                /> 
                </VStack>
                </HStack>
                <Text fontSize={"18px"}>Beskrivning av priset</Text>
                <Input
                    minW={100}
                    placeholder="Ange beskrivning av priset"
                    onChange={(event) => {
                    setDescription(event.currentTarget.value);
                    }}
                />                   
            </Box>
            <Box
              borderRadius={"10px"}
              background={"yellow.200"}
              padding={"40px"}
              shadow={"2xl"}
            >
              <Text fontSize={"24px"}>Villkor för vinnare</Text>
              <HStack spacing={10}>
                <VStack align="left">              
                <Text fontSize={"18px"}>Urval på klasser</Text>
                <Input
                    minW={100}
                    placeholder="Ange t.ex. 'K', 'M', 'JL'"
                    onChange={(event) => {
                    if (disciplinesCond === event.currentTarget.value) {
                        setDisciplinesCond("");
                    } else {
                        setDisciplinesCond(event.currentTarget.value);
                    }
                    }}
                />
                </VStack>
                <VStack align="left">
                <Text fontSize={"18px"}>Urval på startnummerintervall</Text>
                <Input
                    minW={100}
                    placeholder="Ange t.ex. '1-100, 201-300'"
                    onChange={(event) => {
                    if (startnumberSequencesCond === event.currentTarget.value) {
                        setStartnumberSequencesCond("");
                    } else {
                        setStartnumberSequencesCond(event.currentTarget.value);
                    }
                    }}
                />              
                </VStack>
                </HStack>
                <HStack spacing={10}>
                  <VStack align="left">
                <Text fontSize={"18px"}>Urval på lagnamn</Text>
                <Input
                    minW={100}
                    placeholder="Ange t.ex. '*FIF'"
                    onChange={(event) => {
                    if (teamNameCond === event.currentTarget.value) {
                        setTeamNameCond("");
                    } else {
                        setTeamNameCond(event.currentTarget.value);
                    }
                    }}
                /> 
                </VStack>
                <VStack align="left">
                  <Text fontSize={"18px"}>Urval på tid i mål</Text>
                <Checkbox
                  isChecked={completedCond}
                  onChange={(event) => {
                    setCompletedCond(event.currentTarget.checked);
                }}>Har fullföljt</Checkbox>   
                </VStack>                
                </HStack>     
            </Box>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="blue"
            mr={3}
            onClick={handleSubmit}
            isDisabled={
              name == null || name.trim().length == 0 || competitionId == null 
              || nrOfWinners == null || nrOfWinners < 1
            }
          >
            Lägg till lottpris
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Avbryt
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddLotteryModal;
